import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getOffice,
  getIdOffice,
  createOffice,
  updateOffice,
  createOfficeSequence,
  uploadImage,
  deleteImageOffice,
  // deleteById,
} from "./officeAPI";
import createTransform from "redux-persist/es/createTransform";

const initialState = {
  data: [],
  dataId: null,
  loading: false,
  error: null,
  pageNo: 1,
  pageSize: 10,
  totalRecord: 0,
  selected: null,
  result: null,
  permissionBasicInfo: [],
  permissionConfiguration: [],
};

export const fetchOffice = createAsyncThunk(
  "office/fetchParameter",
  async (payload) => {
    const response = await getOffice(payload);
    return response;
  }
);

export const addOffice = createAsyncThunk(
  "office/addParameter",
  async (payload) => {
    const response = await createOffice(payload);
    return response;
  }
);
export const removeImageOffice = createAsyncThunk(
  "office/removeImageOffice",
  async (payload) => {
    const response = await deleteImageOffice(payload);
    return response;
  }
);

export const addOfficeSequnce = createAsyncThunk(
  "office/addOfficeSequnce",
  async (payload) => {
    const response = await createOfficeSequence(payload);
    return response;
  }
);

export const editOffice = createAsyncThunk(
  "office/editOffice",
  async (payload) => {
    const response = await updateOffice(payload);
    return response;
  }
);

export const fetchIdOffice = createAsyncThunk(
  "office/fetchIdParameter",
  async (id) => {
    const response = await getIdOffice(id);
    return response;
  }
);

// export const removeById = createAsyncThunk(
//   "office/removeById",
//   async (payload) => {
//     const response = await deleteById(payload);
//     return response;
//   }
// );

export const addUpload = createAsyncThunk(
  "office/addUpload",
  async ({ id, file }) => {
    const response = await uploadImage(id, file);
    return response;
  }
);

export const businessParameterSlice = createSlice({
  name: "office",
  initialState,
  reducers: {
    resetData: () => initialState,
    setSelected: (state, action) => {
      state.selected = action.payload;
    },
    setPermissionBasicInfo: (state, action) => {
      state.permissionBasicInfo = action.payload;
    },
    setPermissionConfiguration: (state, action) => {
      state.permissionConfiguration = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchOffice.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchOffice.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload.data.data;
        state.pageNo = action.payload.data.pageNo;
        state.pageSize = action.payload.data.pageSize;
        state.totalRecord = action.payload.data.totalRecord;
      })
      .addCase(fetchIdOffice.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchIdOffice.fulfilled, (state, action) => {
        state.loading = false;
        state.dataId = action.payload.data.data;
      })

      .addCase(addOffice.pending, (state) => {
        state.loading = true;
      })
      .addCase(addOffice.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(addOfficeSequnce.pending, (state) => {
        state.loading = true;
      })
      .addCase(addOfficeSequnce.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(removeImageOffice.pending, (state) => {
        state.loading = true;
      })
      .addCase(removeImageOffice.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })

      .addCase(editOffice.pending, (state) => {
        state.loading = true;
      })
      .addCase(editOffice.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(addUpload.pending, (state) => {
        state.loading = true;
      })
      .addCase(addUpload.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      });
    // .addCase(removeById.pending, (state) => {
    //   state.loading = true;
    // })
    // .addCase(removeById.fulfilled, (state, action) => {
    //   state.loading = false;
    //   state.result = action.payload;
    // })
  },
});

export const {
  resetData,
  setSelected,
  setPermissionBasicInfo,
  setPermissionConfiguration,
} = businessParameterSlice.actions;

export const selectOffice = (state) => state.office.data;
export const selectIdOffice = (state) => state.office.dataId;
export const selectLoading = (state) => state.office.loading;
export const selectError = (state) => state.office.error;
export const selectPageNo = (state) => state.office.pageNo;
export const selectPageSize = (state) => state.office.pageSize;
export const selectTotalRecord = (state) => state.office.totalRecord;
export const selectSelected = (state) => state.office.selected;
export const selectResult = (state) => state.office.result;
export const selectPermissionBasicInfo = (state) =>
  state.office.permissionBasicInfo;
export const selectPermissionConfiguration = (state) =>
  state.office.permissionConfiguration;

export default businessParameterSlice.reducer;
